import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";

interface StateInterface {
  requests: {};
  requestsOutdated: boolean;
};

const initialState: StateInterface = {
  requests: {},
  requestsOutdated: false
};

export const paymentsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_PAYMENTS_SAVE_LIST_SUCCESS:
    {
      const request: string = action.payload?.request;
      let requests = !!state.requests ? {...state.requests} : {};
      const count: number = !!action.payload?.count ? action.payload?.count : 0;
      const payments: PaymentInterface[] = !!action.payload?.payments ? action.payload?.payments : [];

      requests[request] = {
        count: count,
        payments: [...payments]
      };

      return {
        ...state,
        requests: {...requests},
        requestsOutdated: false
      };
    }

    case Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS:
    {
      return {
        ...initialState,
        requestsOutdated: true
      };
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
